function fire(obj, name, data) {
  // return Rails.fire(obj, name, data);
  // Modern replacement for Rails.fire
  const event = new CustomEvent(name, {
    bubbles: true,
    cancelable: true,
    detail: data
  });
  obj.dispatchEvent(event);
  return event;
}

export {
  fire
};
